import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { QueryParams } from "@router/route-params";
import { selectedAnalyticsTimeFrameSelector } from "@store/analytics/analytics-selector";
import { DEFAULT_TIME_FRAME, setSelectedAnalyticsTimeFrame } from "@store/analytics/analytics-slice";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { AVAILABLE_TIME_FRAMES } from "@utils/time-utils";
import { useCallback, useEffect } from "react";
import { useMatch } from "react-router-dom";

/** Specify base number to parse integers from */
const RADIX = 10;

/**
 * Hook that listens to changes in the URL and updates the selected time frame
 * for the analytics page.
 */
export function useAnalytics() {
  const $ = _c(6);
  const {
    getQueryParam
  } = useAppNavigation();
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const selectedAnalyticsTimeFrame = useAppSelector(selectedAnalyticsTimeFrameSelector);
  const replaceUrlParam = _temp;
  const isWorkspaceRoute = useMatch(`/${companyId}/analytics/workspace`);
  let t0;
  let t1;
  if ($[0] !== dispatch || $[1] !== getQueryParam || $[2] !== isWorkspaceRoute || $[3] !== selectedAnalyticsTimeFrame) {
    t0 = () => {
      if (!isWorkspaceRoute) {
        return;
      }
      const selectedTimeFrameQuery = getQueryParam(QueryParams.timeFrame);
      if (!selectedTimeFrameQuery && selectedAnalyticsTimeFrame) {
        replaceUrlParam({
          key: QueryParams.timeFrame,
          value: selectedAnalyticsTimeFrame.toString()
        });
        return;
      }
      if (!selectedTimeFrameQuery) {
        return;
      }
      const newSelectedTimeFrame = parseInt(selectedTimeFrameQuery, RADIX);
      if (!AVAILABLE_TIME_FRAMES.includes(newSelectedTimeFrame)) {
        replaceUrlParam({
          key: QueryParams.timeFrame,
          value: DEFAULT_TIME_FRAME.toString()
        });
        return;
      }
      dispatch(setSelectedAnalyticsTimeFrame(newSelectedTimeFrame));
    };
    t1 = [selectedAnalyticsTimeFrame, getQueryParam, replaceUrlParam, dispatch, isWorkspaceRoute];
    $[0] = dispatch;
    $[1] = getQueryParam;
    $[2] = isWorkspaceRoute;
    $[3] = selectedAnalyticsTimeFrame;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
}
function _temp(t0) {
  const {
    key,
    value
  } = t0;
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.replaceState({}, "", url.toString());
}